import { createApi } from '@reduxjs/toolkit/query/react';

import {
  AudioConversation,
  AudioConversationDetail,
} from '../types/audio-conversation-types';
import { baseQueryWithErrorHandling } from './baseQuery';

export const audioConversationsApiClient = createApi({
  reducerPath: 'audioConversationsApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['AudioConversations', 'AudioConversationDetail'] as const,
  endpoints: (builder) => ({
    getAudioConversations: builder.query<AudioConversation[], string>({
      query: (matter_id) => `api/matters/${matter_id}/audio-conversations/`,
      providesTags: (result, error, matter_id) => [
        { type: 'AudioConversations', id: matter_id },
      ],
    }),
    getAudioConversation: builder.query<
      AudioConversation,
      { matterId: string; conversationId: string }
    >({
      query: ({ matterId, conversationId }) => ({
        url: `api/matters/${matterId}/audio-conversations/${conversationId}/`,
        method: 'GET',
      }),
      providesTags: (result, error, { matterId, conversationId }) => [
        { type: 'AudioConversations', id: `${matterId}-${conversationId}` },
      ],
    }),
    getAudioConversationDetail: builder.query<
      AudioConversationDetail,
      { matterId: string; conversationId: string }
    >({
      query: ({ matterId, conversationId }) => ({
        url: `api/matters/${matterId}/audio-conversations/${conversationId}/details/`,
        method: 'GET',
      }),
      providesTags: (result, error, { matterId, conversationId }) => [
        {
          type: 'AudioConversationDetail',
          id: `${matterId}-${conversationId}`,
        },
      ],
    }),
    getAudioConversationDetailList: builder.query<
      AudioConversationDetail[],
      string
    >({
      query: (matter_id) =>
        `api/matters/${matter_id}/audio-conversations/list_details/`,
      providesTags: (result, error, matter_id) => [
        { type: 'AudioConversations', id: `${matter_id}-details` },
      ],
    }),
  }),
});

export const {
  useGetAudioConversationsQuery,
  useGetAudioConversationQuery,
  useGetAudioConversationDetailQuery,
  useGetAudioConversationDetailListQuery,
} = audioConversationsApiClient;
